import { z } from "zod";

export const PRODUCT_VISUAL_KEYS = [
  "shirt", "pants", "hoodie", "jacket", "boxer", "jeans", "short-sleeve-shirt",
  "long-sleeve-shirt", "swimwear", "shorts", "socks", "dress", "skirt", "scarf", "gloves",
  "shoe", "open-shoe",
  "perfume", "accessory", "chain", "watch", "bracelet", "belt", "cap", "bag", "wallet", "glasses",
  "package",
] as const;

export type ProductVisualKey = (typeof PRODUCT_VISUAL_KEYS)[number];
export type ProductVisualGroup = "Indumentaria" | "Calzado" | "Accesorios" | "Generales";

export const productVisualKeySchema = z.enum(PRODUCT_VISUAL_KEYS);

export const PRODUCT_VISUAL_OPTIONS: ReadonlyArray<{
  key: ProductVisualKey;
  label: string;
  group: ProductVisualGroup;
}> = [
  { key: "shirt", label: "Remera", group: "Indumentaria" },
  { key: "pants", label: "Pantalón", group: "Indumentaria" },
  { key: "hoodie", label: "Buzo", group: "Indumentaria" },
  { key: "jacket", label: "Campera", group: "Indumentaria" },
  { key: "boxer", label: "Boxer", group: "Indumentaria" },
  { key: "jeans", label: "Jean", group: "Indumentaria" },
  { key: "short-sleeve-shirt", label: "Camisa corta", group: "Indumentaria" },
  { key: "long-sleeve-shirt", label: "Camisa larga", group: "Indumentaria" },
  { key: "swimwear", label: "Malla", group: "Indumentaria" },
  { key: "shorts", label: "Bermuda", group: "Indumentaria" },
  { key: "socks", label: "Medias", group: "Indumentaria" },
  { key: "dress", label: "Vestido", group: "Indumentaria" },
  { key: "skirt", label: "Pollera", group: "Indumentaria" },
  { key: "scarf", label: "Bufanda", group: "Indumentaria" },
  { key: "gloves", label: "Guantes", group: "Indumentaria" },
  { key: "shoe", label: "Zapatilla", group: "Calzado" },
  { key: "open-shoe", label: "Ojotas", group: "Calzado" },
  { key: "perfume", label: "Perfume", group: "Accesorios" },
  { key: "accessory", label: "Accesorio", group: "Accesorios" },
  { key: "chain", label: "Cadena", group: "Accesorios" },
  { key: "watch", label: "Reloj", group: "Accesorios" },
  { key: "bracelet", label: "Pulsera", group: "Accesorios" },
  { key: "belt", label: "Cinto", group: "Accesorios" },
  { key: "cap", label: "Gorra", group: "Accesorios" },
  { key: "bag", label: "Bolso", group: "Accesorios" },
  { key: "wallet", label: "Billetera", group: "Accesorios" },
  { key: "glasses", label: "Lentes", group: "Accesorios" },
  { key: "package", label: "Genérica", group: "Generales" },
];

export const PRODUCT_VISUAL_GROUPS: ProductVisualGroup[] = ["Indumentaria", "Calzado", "Accesorios", "Generales"];
